import { useCallback, useEffect, useState } from 'react';
import { getPartnerObservations } from 'modules/partners/api/getPartnerObservations';
import { Observation } from 'types';

export const usePartnerObservations = (
  partnerId: string,
  societyId: string
) => {
  const [observations, setObservations] = useState<Observation[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchPartnerObservations = useCallback(async () => {
    if (!partnerId || !societyId) return;

    try {
      setIsLoading(true);
      setIsError(false);

      const observations = (await getPartnerObservations({
        partnerId,
        societyId,
      })) as Observation[];

      setObservations(observations);
    } catch (error) {
      console.error('Failed to fetch partner observations:', error);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [partnerId, societyId]);

  useEffect(() => {
    fetchPartnerObservations();
  }, [fetchPartnerObservations]);

  return {
    observations,
    isLoading,
    isError,
    refetch: fetchPartnerObservations,
  };
};
